import React from 'react';
import Livres1 from '../../images/Livres1.jpg';
import Livres2 from '../../images/Livres2.jpg';

const LivresContent = () => {
    return (
        <div className="category-content">
            <h3 className="content-title">Nos Livres</h3>
            <p className="content-description">Voici un aperçu des livres que vous trouverez dans notre boutique</p>
            <p className="content-subtitle">Sur l'histoire de la région, Touristiques, Sur les autorails...</p>
            <div className="product-grid">
                <div className="product-item">
                    <img src={Livres1} alt="Livres collection 1" className="product-image" />
                </div>
                <div className="product-item">
                    <img src={Livres2} alt="Livres collection 2" className="product-image" />
                </div>
            </div>
        </div>
    );
};

export default LivresContent;
